export const ROLES = {
  UPPER_ADMIN: 'UPPER_ADMIN',
  ADMIN:       'ADMIN',
  SSL:         'SSL',
  SL:          'SL',
};

export const ROLE_LABELS = {
  UPPER_ADMIN: 'Upper Administration',
  ADMIN:       'Admin',
  SSL:         'Senior SL',
  SL:          'SL',
};

/** Returns true if the user's role is at or above the required level. */
export function hasRole(user, ...allowedRoles) {
  return user && allowedRoles.includes(user.role);
}

export const isUpperAdmin  = (user) => user?.role === ROLES.UPPER_ADMIN;
export const isAdminOrAbove = (user) => [ROLES.UPPER_ADMIN, ROLES.ADMIN].includes(user?.role);
export const isSSLOrAbove  = (user) => [ROLES.UPPER_ADMIN, ROLES.ADMIN, ROLES.SSL].includes(user?.role);
export const isSL          = (user) => user?.role === ROLES.SL;
